import {ReviewAnalysisCompaniesSortKeyType} from './review-companies-type';

type SortKeysType = ['total', 'avgRating', 'replied', 'avgResponseSpeed'];

const sortKeys: SortKeysType = ['total', 'avgRating', 'replied', 'avgResponseSpeed'];

const stringKeysCast: Array<string> = sortKeys;

export function isReviewAnalysisCompanySortKey(stringValue: string): stringValue is ReviewAnalysisCompaniesSortKeyType {
    return stringKeysCast.includes(stringValue);
}
